import { callEndpoint, checkClientToken } from '../backend';
import { initialize as initializeAlertService } from './alerts';
import { initialize as initializeSharingService } from './sharing';
import { getStore } from '../store';
import { subscribe, definitions } from '../message-broker';

export const getMember = async (memberId) => {
  const response = await callEndpoint(callEndpoint.endpoints.getMember, {
    memberId,
  });
  return response;
};

export const updateTitle = async (title) => {
  await callEndpoint(callEndpoint.endpoints.updateProfile, { title });
  return checkClientToken();
};

export const updateBioDescription = async (bioDescription) => {
  await callEndpoint(callEndpoint.endpoints.updateProfile, { bioDescription });
  return checkClientToken();
};

export const updateImage = async (dataUrlImage) => {
  await callEndpoint(callEndpoint.endpoints.updateProfile, {
    image: dataUrlImage,
  });
  return checkClientToken();
};

export const updateCoverImage = async (dataUrlImage) => {
  await callEndpoint(callEndpoint.endpoints.updateProfile, {
    coverImage: dataUrlImage,
  });
  return checkClientToken();
};

export const unsubscribeFromEmail = async (email) => {
  await callEndpoint(callEndpoint.endpoints.unsubscribeFromEmail, { email });
  return checkClientToken();
};

export const getSharingNotifications = async () => {
  const notifications = await callEndpoint(
    callEndpoint.endpoints.getSharingActivitiesByMember,
  );

  // Get the type label matchup from meta-store
  const itemTypeDisplayNames =
    window.DECKEE_CONFIG?.sharing?.itemTypeDisplayNames;
  const formattedNotifications = notifications.map((notif) => ({
    ...notif,
    itemTypeLabel: itemTypeDisplayNames[notif.itemType],
  }));

  return formattedNotifications;
};

const updateLastActive = async () => {
  const { currentMember } = getStore().getState().backendService;
  if (currentMember) {
    // Data is provided by API key in header and time is generated on server side
    await callEndpoint(callEndpoint.endpoints.updateLastActive);
  }
};

export const initialize = async () => {
  initializeAlertService();
  initializeSharingService();
  updateLastActive();
  subscribe(definitions.window.resume, async () => {
    await updateLastActive();
  });
};
